import Pagination from '../../components/pagination/Pagination';
import { useMemo, useEffect, useState } from 'react';
import { ListDataProps } from './data';
import Select, { components } from 'react-select';
import { s } from './SearchResultList.styles';
import { useModal } from '../../../context/ModalContext';
import GameService from '../../../service/game/GameService';
import AddInterestItemModal from '../../../page/components/modal/AddInterestItem';
import InterestService from '../../../service/Interest';
import { isLogin } from '../../../utils/auth';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// ✅ 선택된 옵션일 때만 체크 아이콘 표시
const CustomOption = (props: any) => {
  const { isSelected, isFocused, innerRef, innerProps, data } = props;
  return (
    <s.LankSelect
      ref={innerRef}
      {...innerProps}
      isFocused={props.isFocused}
      isSelected={props.isSelected}
    >
      <span>{data.label}</span>

      {/* ✅ 선택된 항목에만 이미지 렌더 */}
      {isSelected && (
        <img
          src="/assets/images/game/icon_select_check.svg"
          alt="selected"
          width={16}
          height={16}
          style={{ flex: '0 0 auto' }}
        />
      )}
    </s.LankSelect>
  );
};

const ListTypeContent = () => {
  const [sortOption, setSortOption] = useState<string>('우승 많은순');
  const [selectedRegion, setSelectedRegion] = useState<string>('전체게임');
  const [gameList, setGameList] = useState<any[]>([]);
  const [rankingList, setRankingList] = useState<any[]>([]);
  const [selectedGameId, setSelectedGameId] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [regionOptions, setRegionOptions] = useState<any[]>([]);
  const [total, setTotal] = useState<number>(0);
  const navigate = useNavigate();
  const sortOptions = [
    { value: '우승 많은순', label: '우승 많은순' },
    { value: '우승 적은순', label: '우승 적은순' },
    { value: '낮은 가격순', label: '낮은 가격순' },
    { value: '높은 가격순', label: '높은 가격순' },
  ];

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      borderRadius: '8px',
      height: '36px',
      fontSize: '14px',
      fontWeight: 500,
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: 'rgba(2, 32, 71, 0.05)',
      border: 'none',
      ':hover': {
        background: 'rgba(0, 27, 55, 0.10)',
      },
      boxShadow: 'none',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
      color: '#B0B8C1',
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: 'rgba(0, 12, 30, 0.80)',
      fontSize: '14px', // 크기
      display: 'block',
      alignItems: 'center', // 세로 가운데 정렬
      padding: '0 0 0 14px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      color: '#B0B8C1',
      padding: '0 14px 0 0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: 0,
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: '12px',
      padding: '6px',
      boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.12)',
      border: '1px solid E1E2E4',
      overflow: 'hidden',
    }),
  };
  const pageSize = 5; // 한 페이지에 보여줄 개수
  const [currentPage, setCurrentPage] = useState(1);

  // ✅ 2. 상태 및 기본 함수
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [expandedMemos, setExpandedMemos] = useState<Set<number>>(new Set());
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());
  const { modalDispatch } = useModal();
  const [expandedTags, setExpandedTags] = useState<{ [key: number]: boolean }>(
    {},
  );
  const toggleMemoExpand = (index: number) => {
    setExpandedMemos((prev) => {
      const newSet = new Set(prev);
      newSet.has(index) ? newSet.delete(index) : newSet.add(index);
      return newSet;
    });
  };

  const toggleExpand = (index: number) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      newSet.has(index) ? newSet.delete(index) : newSet.add(index);
      return newSet;
    });
  };

  const renderTags = (tags: string[], index: number) => {
    const isExpanded = expandedRows.has(index);
    const maxVisibleTags = 2;

    if (!tags || tags.length === 0) return null;

    if (isExpanded) {
      return (
        <>
          {tags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}

          <s.TagText
            onClick={(e) => {
              e.stopPropagation();
              toggleExpand(index);
            }}
          >
            <span>접기</span>
            <img
              src="/assets/images/arrow/arrow-down-gray.svg"
              alt=""
              style={{ width: '16px', transform: 'rotate(180deg)' }}
            />
          </s.TagText>
        </>
      );
    } else {
      const visibleTags = tags.slice(0, maxVisibleTags);
      const remainingCount = tags.length - maxVisibleTags;

      return (
        <>
          {visibleTags.map((tag, i) => (
            <s.TagText key={`${index}-${i}`}>{tag}</s.TagText>
          ))}
          {remainingCount > 0 && (
            <s.TagText
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand(index);
              }}
            >
              +{remainingCount}개
            </s.TagText>
          )}
        </>
      );
    }
  };

  const handleDisLikeItem = async (iidx: number) => {
    try {
      await InterestService.dislike(iidx);
      alert('관심물건에서 삭제되었습니다');

      // 리스트 상태 갱신
      setRankingList((prev) =>
        prev.map((item) =>
          (item.iidx || item.itemId) === iidx
            ? { ...item, is_like: false }
            : item,
        ),
      );
    } catch (err) {
      alert('삭제 중 오류 발생');
      console.error(err);
    }
  };

  const setSelectedItem = (item: any) => {
    console.log('선택된 항목:', item);
  };

  const setMode = (mode: string) => {
    console.log('모드 변경:', mode);
  };

  const page = 'mypage';
  const tab = '관심물건';
  const isNPL = false;
  const sortedData = useMemo(() => {
    const arr = [...rankingList];
    switch (sortOption) {
      case '우승 많은순':
        return arr.sort((a, b) => Number(b.win_cnt) - Number(a.win_cnt));
      case '우승 적은순':
        return arr.sort((a, b) => Number(a.win_cnt) - Number(b.win_cnt));
      case '낮은 가격순':
        return arr.sort((a, b) => Number(a.minPrice) - Number(b.minPrice));
      case '높은 가격순':
        return arr.sort((a, b) => Number(b.minPrice) - Number(a.minPrice));
      default:
        return arr;
    }
  }, [rankingList, sortOption]);
  useEffect(() => {
    const fetchGameList = async () => {
      try {
        const res = await GameService.list(1, 100);
        const list = res?.data?.list || [];
        setGameList(list);

        const options = [
          { value: '전체게임', label: '전체게임' },
          ...list.map((g: any) => ({
            value: g.game_id,
            label: g.title,
          })),
        ];
        setRegionOptions(options);

        setSelectedGameId(null);
      } catch (err) {
        console.error('게임 목록 로딩 실패:', err);
      }
    };

    fetchGameList();
  }, []);

  const filteredGameList = useMemo(() => {
    if (!gameList || gameList.length === 0) return [];
    if (selectedGameId === null) return gameList;
    return gameList.filter((g) => g.game_id === selectedGameId);
  }, [gameList, selectedGameId]);

  useEffect(() => {
    if (selectedGameId === null) return;
    if (filteredGameList.length > 0) {
      setSelectedGameId(filteredGameList[0].game_id);
    }
  }, [filteredGameList, selectedGameId]);

  useEffect(() => {
    const fetchWinningList = async () => {
      setLoading(true);
      try {
        const sortMap: any = {
          '우승 많은순': 'AD',
          '우승 적은순': 'AA',
          '낮은 가격순': 'BA',
          '높은 가격순': 'BD',
        };

        const sortValue = sortMap[sortOption] || 'AD';

        const storedPlayerId: string | undefined =
          sessionStorage.getItem('player_id') || undefined;

        const res = await GameService.getWinningItems({
          playerId: localStorage.getItem('token') ? undefined : storedPlayerId,
          gameId: selectedGameId ? String(selectedGameId) : undefined,
          sort: sortValue,
          limit: pageSize,
          page: currentPage,
        });
        setTotal(Number(res?.data?.totalCount) || 0);
        setRankingList(res?.data?.list || []);
      } catch (err) {
        console.error('우승 목록 로딩 실패:', err);
      } finally {
        setLoading(false);
      }
    };

    if (gameList.length > 0) {
      fetchWinningList();
    }
  }, [sortOption, selectedGameId, currentPage, gameList]);

  const totalPages = Math.ceil(total / pageSize);
  useEffect(() => {
    setCurrentPage(1);
  }, [sortOption, selectedGameId]);
  const handleLikeClick = (item: any) => {
    if (!isLogin()) {
      alert('로그인이 필요합니다.');
      navigate('/login');
      return;
    }

    if (item.is_like) {
      handleDisLikeItem(item.iidx || item.itemId);
    } else {
      setSelectedIdx(item.iidx || item.itemId);
      setShowLikeModal(true);
    }
  };

  // 현재 페이지 데이터
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return sortedData.slice(start, start + pageSize);
  }, [sortedData, currentPage, pageSize]);

  // 정렬 바뀌면 1페이지로 리셋
  useEffect(() => {
    setCurrentPage(1);
  }, [sortOption]);
  const toggleTags = (index: number) => {
    setExpandedTags((prev: { [key: number]: boolean }) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  return (
    <s.ListBox>
      <s.SelectBoxWrap>
        <s.SelectBox>
          <div style={{ width: 120 }}>
            <Select
              options={sortOptions}
              value={sortOptions.find((opt) => opt.value === sortOption)}
              onChange={(selected) =>
                setSortOption(selected?.value || '우승 많은순')
              }
              styles={customStyles}
              isSearchable={false}
              components={{
                Option: CustomOption,
              }}
            />
          </div>
        </s.SelectBox>
        <s.SelectBox>
          <div style={{ width: 175 }}>
            <Select
              options={regionOptions}
              value={
                regionOptions.find((opt) =>
                  selectedGameId === null
                    ? opt.value === '전체게임'
                    : opt.value === selectedGameId,
                ) || regionOptions[0] // fallback
              }
              onChange={(selected) => {
                if (selected?.value === '전체게임') {
                  setSelectedGameId(null);
                } else {
                  setSelectedGameId(selected?.value);
                }
              }}
              styles={customStyles}
              isSearchable={false}
              components={{
                Option: CustomOption,
              }}
            />
          </div>
        </s.SelectBox>
      </s.SelectBoxWrap>
      <s.List>
        {rankingList.map((item, index) => {
          return (
            <s.ListCardContentBoxWrap
              onClick={() => window.open(`/auction/detail/${item.iidx}`)}
              style={{ cursor: 'pointer' }}
            >
              {' '}
              <s.ItemInfoBox>
                <div>
                  {item.caseno} ・ {item.category}
                </div>
                <s.ItemTypeChip>경매</s.ItemTypeChip>
              </s.ItemInfoBox>
              <s.ListCardContentBox>
                <s.CardTextBox>
                  <s.CardTitle>
                    {item.address ? <>{item.address}</> : <>업데이트 준비중</>}
                  </s.CardTitle>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <s.CardPrice>
                      감정가{' '}
                      <strong>
                        {Number(item.appraisalPrice).toLocaleString()}원
                      </strong>
                    </s.CardPrice>
                    {item.bidprice ? (
                      <s.BidPrice>
                        낙찰가{' '}
                        <strong>
                          {Number(item.bidprice).toLocaleString()}원
                        </strong>
                      </s.BidPrice>
                    ) : (
                      <s.BidPrice>
                        최저가{' '}
                        <strong>
                          {Number(
                            item.minPrice || item.minPrice,
                          ).toLocaleString()}
                          원
                        </strong>
                      </s.BidPrice>
                    )}
                  </div>
                  <s.HashTagWrapper
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <s.WinLableWrap>
                      <s.WinLable>{Number(item.win_cnt)}회 우승</s.WinLable>
                    </s.WinLableWrap>
                    {(() => {
                      const tags = [
                        { type: 'red', value: item.status },
                        ...(item.tag || []).map((t: string) => ({
                          type: 'gray',
                          value: t,
                        })),
                      ];

                      const visibleCount = 2;
                      const isExpanded = expandedTags[index] || false;

                      const visibleTags = isExpanded
                        ? tags
                        : tags.slice(0, visibleCount);
                      const hiddenCount = tags.length - visibleCount;

                      return (
                        <>
                          {visibleTags.map((tag, i) => {
                            const value = tag.value ?? '';

                            if (value.includes('대항력')) {
                              return <TagBlue key={i}>{value}</TagBlue>;
                            }

                            if (tag.type === 'red') {
                              return <TagRed key={i}>{value}</TagRed>;
                            }

                            if (tag.type === 'blue') {
                              return <TagBlue key={i}>{value}</TagBlue>;
                            }

                            return <TagGray key={i}>{value}</TagGray>;
                          })}

                          {hiddenCount > 0 && !isExpanded && (
                            <TagGray onClick={() => toggleTags(index)}>
                              +{hiddenCount}
                            </TagGray>
                          )}
                          {hiddenCount > 0 && isExpanded && (
                            <TagGray
                              onClick={() => toggleTags(index)}
                              style={{
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                              }}
                            >
                              접기
                              <img
                                alt=""
                                src="/assets/images/arrow/arrow-down-gray.svg"
                                style={{
                                  width: '16px',
                                  transform: 'rotate(180deg)',
                                  marginLeft: '4px',
                                }}
                              />
                            </TagGray>
                          )}
                        </>
                      );
                    })()}
                  </s.HashTagWrapper>
                </s.CardTextBox>
                <s.CardImgBox>
                  <div style={{ position: 'relative' }}>
                    <img
                      src={item.thumb || '/assets/images/no-image.svg'}
                      alt=""
                      style={{
                        height: 80,
                        width: 80,
                        borderRadius: 8,
                      }}
                    />
                    <Imgheart>
                      <img
                        src={`/assets/images/game/${item.is_like ? 'heart_on' : 'heart_off'}.svg`}
                        alt="like"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLikeClick(item);
                        }}
                      />
                    </Imgheart>
                  </div>

                  <s.ViewCount>
                    <img src="/assets/images/icon/view-gray.svg" alt="" />
                    <span>{item.count ?? 0}회</span>
                  </s.ViewCount>
                </s.CardImgBox>
              </s.ListCardContentBox>
            </s.ListCardContentBoxWrap>
          );
        })}
      </s.List>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={(page: number) => setCurrentPage(page)}
      />
      {showLikeModal && selectedIdx !== null && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={selectedIdx}
          mode="add"
          selectedItem={{
            iidx: selectedIdx,
            group: '',
            group_idx: 0,
            level: 0,
            memo: '',
          }}
          setActiveItem={() => {}}
          checkIsLikeItem={(iidx: number) => {
            setRankingList((prev) =>
              prev.map((item) =>
                item.iidx === iidx ? { ...item, is_like: true } : item,
              ),
            );
          }}
        />
      )}
    </s.ListBox>
  );
};

export default ListTypeContent;

const TagRed = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #fff0f0;
  color: #f04452;

  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const TagGray = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #f4f5f9;
  color: #4e5968;

  /* Re_SPOQA/body/med_12 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const TagBlue = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #e7f0fe;
  color: #008aff;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;
const Imgheart = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
`;
